import { configureStore } from "@reduxjs/toolkit";
import { createTransform, persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import thunk from "redux-thunk";

import rootReducer from "./reducers";
import { gtmMiddleware } from "../utils/gtmMiddleware";
import { parseJSON } from "../utils/jsonUtil";

const dateTransform = createTransform(null, (outBoundState, k) => {
  var val = JSON.stringify(outBoundState);
  return parseJSON(val);
});

// The whole auth slice is persisted to sessionStorage, so a prior purge's `hasCheckedUser: true`
// (set so an in-app sign-out doesn't flash the loading gate) would otherwise survive into a later
// load of this tab and let routing skip re-verifying against oidc-client's own (authoritative)
// session. Force it false on every write so a fresh load always re-runs the bootstrap check.
export const authTransform = createTransform(
  (inboundState: any) => ({ ...inboundState, hasCheckedUser: false }),
  null,
  {
    whitelist: ["auth"],
  }
);

const persistConfig = {
  key: "root",
  storage: storageSession,
  transforms: [dateTransform, authTransform],
  blacklist: ["appConfigs"],
};

const middlewares = [];

middlewares.push(thunk);

if (window.__config.GTM_CONTAINER) {
  middlewares.push(gtmMiddleware);
}

if (process.env.NODE_ENV === `development`) {
  const { logger } = require(`redux-logger`);
  middlewares.push(logger);
}

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  devTools: process.env.NODE_ENV === "development",
  reducer: persistedReducer,
  middleware: middlewares,
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
